import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal, Image } from 'react-bootstrap';
import PhotosModal from './PhotosModal';
import AddHotelDocumentForm from './AddHotelDocumentForm';


class HotelDocumentForm extends React.Component {
  constructor() {
    super();
    this.state = {
      show: false,
      documents: [],
      files: []
    };
    this.showAddDocument = this.showAddDocument.bind(this);
    this.hideAddDocument = this.hideAddDocument.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }
  showAddDocument() {
    this.setState({ show: true, files: [], documents: [] });
  }
  hideAddDocument() {
    this.setState({ show: false });
  }
  onDrop(acceptedFiles){
    if(acceptedFiles.length > 1){
      alert("Please select single document to upload.");
      return
    }
    let files = (<ul className="list-group mt-2">
                  {acceptedFiles.length > 0 && acceptedFiles.map(acceptedFile => (
                    <li className="list-group-item list-group-item-success">
                      {acceptedFile.name}
                    </li>
                  ))}
                </ul>)
    this.setState({
      documents: acceptedFiles,
      files: files
    })

  }
  handleSubmit(values){
    let payload = {};
    const documentName = values.target.document_name.value;
    const isExistingURL = values.target.document_option.checked;
    const id = this.props.hotel.id;
    
    if(typeof(documentName) == 'undefined' || documentName.trim() == '') {
      values.preventDefault();
      alert("Please provide document name");
      return
    }

    if(isExistingURL){
      const documentURL = values.target.existing_url.value;

      if(typeof(documentURL) == 'undefined' || documentURL == '') {
        values.preventDefault();
        alert("Please provide document url");
        return
      }
      payload = {
        document_name: documentName,
        existing_url: documentURL,
        is_existing_url: isExistingURL
      }
    }else{

      if(typeof(this.state.documents) == 'undefined' || this.state.documents == '') {
        values.preventDefault();
        alert("Please upload document");
        return
      }

      payload = {
      document_name: documentName,
      document: this.state.documents,
      is_existing_url: isExistingURL
    }
  }

    this.props.addHotelDocument(id, payload);
    this.hideAddDocument();
  }

  render() {
    return (
        <div className="hotel-documents-header-section">
          <div className="row">
            <div className="col-md-12">
              <h4 className="hotel-highlight">
                Hotel Document(s)
              </h4>
            </div>
          </div>
          <div>
            <Button bsStyle="success" onClick={this.showAddDocument}>Add Document</Button>
          </div>
          {this.state.show && (<Modal show={this.state.show} onHide={this.hideAddDocument} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Add Document</Modal.Title>
          </Modal.Header>
          <Modal.Body>
           <AddHotelDocumentForm
              onDrop={this.onDrop}
              handleSubmit={this.handleSubmit}
              files={this.state.files}
              initialValues={{document_name: '', document_option: false, existing_url: ''}}
           />
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>)}
        </div>
    );
  }
}
HotelDocumentForm.propTypes = {
  handleClose: PropTypes.func.isRequired,
  addHotelDocument: PropTypes.func.isRequired,
};

export default HotelDocumentForm;


// WEBPACK FOOTER //
// src/routes/hotels/components/HotelDocumentForm.js